import { FC, MutableRefObject, ReactNode, useImperativeHandle, useRef, useState } from 'react';
import PaginItem from '../PaginItem';
import { PageWrap } from './style';

export interface IPageRef {
	pageSize: number;
}

export interface ICardProps {
	cardWidth: number;
	cardHeight: number;
	cardTop: number;
	cardLeft: number;
}

interface IPageContainerProps {
	pageRef?: MutableRefObject<IPageRef | undefined>;
	isShowBorder?: boolean;
	pageTitle: string;
	contentTitle?: ReactNode;
	contentEle: ReactNode;
	searchEle: ReactNode;
	pagi?: {
		handlePageChange: (offset: number) => void;
		total: number;
		offset?: number;
		pageType?: 'table' | 'card';
		cardInfo?: {
			width: number;
			height: number;
			rowGap: number;
			colGap: number;
		};
		tableInfo?: {
			headHeight: number;
			height: number;
		};
	};
}

const PageContainer: FC<IPageContainerProps> = ({
	pageTitle,
	contentEle,
	searchEle,
	contentTitle,
	isShowBorder,
	pagi,
	pageRef,
}) => {
	isShowBorder = isShowBorder ?? true;
	if (pagi) {
		pagi.pageType = pagi.pageType ?? 'table';
		pagi.tableInfo = pagi.tableInfo ?? { height: 55, headHeight: 48 };
		pagi.cardInfo = pagi.cardInfo ?? { width: 244, height: 136, rowGap: 18, colGap: 18 };
	}

	const contentRef = useRef<HTMLDivElement>(null);
	const [pageSize, setPageSize] = useState<number>(0);

	useImperativeHandle(
		pageRef,
		() => ({
			pageSize: getPageSize(),
		}),
		[pageRef, pageSize],
	);

	// 获取每页的数量
	const getPageSize: () => number = () => {
		let pageNum: number = 12;

		if (contentRef.current && pagi) {
			const { pageType, cardInfo, tableInfo } = pagi;

			const contentHeight = contentRef.current.offsetHeight;
			const contentWidth = contentRef.current.offsetWidth;

			if (pageType === 'table') {
				const restHeight = contentHeight - (tableInfo?.headHeight as number);
				pageNum = Math.floor(restHeight / (tableInfo?.height as number));
			}
			if (pageType === 'card') {
				const rowSize = Math.floor(
					contentWidth / ((cardInfo?.width as number) + (cardInfo?.rowGap as number)),
				);
				const colSize = Math.ceil(
					contentHeight / ((cardInfo?.height as number) + (cardInfo?.colGap as number)),
				);

				pageNum = rowSize * colSize;
			}
			pageNum = pageNum > 12 ? pageNum : 12;

			setPageSize(pageNum);
		}
		return pageNum;
	};

	return (
		<PageWrap isShowBorder={isShowBorder}>
			<div className="page-title">{pageTitle}</div>
			<div className="search--wrap">{searchEle}</div>
			<div className="content--wrap">
				<div className="content-title">{contentTitle}</div>
				<div className="content-content" ref={contentRef}>
					{contentEle}
				</div>
				{pagi && (
					<div className="pagination--wrap">
						<PaginItem
							total={pagi.total}
							take={pageSize}
							offset={pagi.offset ?? 0}
							handleChange={(offset) => pagi.handlePageChange(offset)}
						/>
					</div>
				)}
			</div>
		</PageWrap>
	);
};

export default PageContainer;
